import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Icon from '../../../ui/Icon'
import { Button } from '../../../buttons/Button'
import { UpcomingRow } from './upcomingRow/UpcomingRow'

import { Booking } from '../../../../types/booking/booking'

type UpcomingListProps = {
  bookingList: Booking[] | null
}

export const UpcomingList = ({ bookingList }: UpcomingListProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation('dashboard')
  const hasBookings = bookingList !== null && bookingList.length > 0

  const goTo = (path: string) => {
    navigate(path)
  }

  return (
    <div className="upcoming-list">
      <div className="ph-row ph-between mb-16">
        <h3>{t('dashboard.upcoming-list.upcoming-bookings')}</h3>
        {hasBookings && (
          <Button
            label={t('dashboard.upcoming-list.view-all-btn')}
            icon={<Icon name="chevR" size={13} />}
            iconPosition="right"
            variant="ghost"
            size="sm"
            onClick={() => goTo('/history')}
          />
        )}
      </div>

      {bookingList === null ? (
        <div className="upcoming-list-empty" aria-hidden="true">
          &mdash;
        </div>
      ) : hasBookings ? (
        <div className="upcoming-list-rows">
          {bookingList.map(item => (
            <UpcomingRow key={item.id} item={item} />
          ))}
        </div>
      ) : (
        <div className="upcoming-list-empty">
          <strong>{t('dashboard.upcoming-list.empty-title')}</strong>
          <p>{t('dashboard.upcoming-list.empty-description')}</p>
          <Button
            label={t('dashboard.upcoming-list.book-court')}
            size="sm"
            onClick={() => goTo('/booking')}
          />
        </div>
      )}
    </div>
  )
}
